import { CalendarWeek } from './CalendarWeek';
import { Day } from '@/domain/termine/type';
import {
  CalendarContext,
  useCalendarContext,
} from '@/domain/termine/features/Calendar/shared/CalendarContext';

export function CalendarGrid() {
  const props = useCalendarContext();

  const days: Day[] = [];
  let current = props.startDate.clone();
  while (!current.isAfter(props.endDate)) {
    days.push(current.clone());
    current = current.add(1, 'day');
  }

  const weeks: Day[][] = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }

  return weeks.map((week, rowIndex) => (
    <div
      key={week[0].format('YYYY-MM-DD')}
      className="last:border-b-0 border-b border-neutrals-N300">
      <CalendarContext.Provider
        value={{
          ...props,
          rowIndex,
        }}>
        <CalendarWeek week={week} termine={props.termine} />
      </CalendarContext.Provider>
    </div>
  ));
}
